import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    this.iconTarget.classList.toggle("fa-eye", !isPassword)
    this.iconTarget.classList.toggle("fa-eye-slash", isPassword)
  }
}
